import {
  Box,
  Card,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import xlsx from "../../assets/images/uploads/xlsx.png";
import { PiX } from "react-icons/pi";
import * as XLSX from "xlsx-js-style";
import axios from "axios";
import { API_URL, NODE_ENV } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import bulkUploadActions from "../../redux/bulkUpload/action";
import commonActions from "../../redux/common/actions";
import { io } from "socket.io-client";
import { cssProperties } from "../../utils/commonCssProperties";
import masterActions from "../../redux/master/actions";
import GreenButton from "../../common/button/greenButton";
import Template from '../../assets/files/BulkUploadTemplate.xlsx'



const Index = () => {
  const theme = useTheme();
  const socketRef = useRef(null);
  const [intervalId, setIntervalId] = useState(null);
  const [courseid, setCourseId] = useState(null);
  const { courseList } = useSelector((state) => state.masterReducer);

  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
    isloader:true,
    });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [Document, setDocument] = useState(null);
  const [documentError, setDocumentError] = useState("");

  let getDataInterval = (bulkuploadid) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("bulkuploadstatus", {
        bulkuploadid,
      });
    }, 2000);
    return intervalId;
  };

  useEffect(() => {
    socketRef.current = io(
      `${API_URL}`,
      NODE_ENV === "production" && {
        path: "/api/socket.io",
        //     transports: ['websocket', 'polling'],
        // reconnection: true,
        // reconnectionAttempts: 5,
        // reconnectionDelay: 1000
      }
    );
    socketRef?.current?.on("bulkuploadmessage", (message) => {
      // let data = message?.data
      if (message?.statusCode === 200) {
        let statustext = message?.data?.trim();
        if (statustext) {
          if (statustext?.toLowerCase() !== "success") {
            setStatusModalOpen({
              open: true,
              isloader:true,
              statustext:
                statustext?.trim() !== "" && statustext !== null
                  ? statustext
                  : statusModalopen.statustext,
            });
          } else {
            setStatusModalOpen({
              open: statustext?.toLowerCase() == "success"? true :false,
              isloader:statustext?.toLowerCase() == "success"? false :true,
              statustext:
                statustext?.toLowerCase() == "success"
                  ? <>
                  <p>Candidate Uploaded Successfully</p>
                  <BluePrimaryButton handleSubmit={() => setStatusModalOpen({
                    open: false,
                    statustext: "",
                    isloaderfalse:false,
                  })} title="Close"></BluePrimaryButton>
                </>
                  : statusModalopen.statustext,
            });
            if (statustext?.toLowerCase() == "success") {
              clearInterval(intervalId);
              setCourseId(null);
              setDocument(null);
              dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "success",
                  show: true,
                  message: "Candidate Uploaded Successfully",
                },
              });
              setTimeout(function () {
                dispatch({
                  type: commonActions.SET_ALERT,
                  payload: {
                    status: "success",
                    show: false,
                    message: null,
                  },
                });
              }, 2000);
            }
          }
        }
        //  else {
        //   setStatusModalOpen({
        //     open: false,
        //     statustext: "",
        //   });
        // }
      }
    });
    return () => (socketRef.current = null);
  }, [dispatch, intervalId, socketRef]);
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
  }, [dispatch]);
  const handleDocumentUpload = (event) => {
    const fileName = event.target.files[0].name;
    const file = event.target.files[0];

    setDocument(file);

    event.target.value = null;
  };
  const handleCloseDocument = () => {
    setDocument(null);
  };
  const handleDocumentDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setDocument(file);
      setDocumentError("");
      event.target.value = null;
    }
  };
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async (Document, courseid) => {
    if (Document) {
      setDocumentError("");
      // let formData = new FormData();
      // const documentFile = new File([Document], Document.name, {
      //   type: "application/xlsx",
      // });
      // formData.append("bulkuploadfile", documentFile);
      dispatch({
        type: bulkUploadActions.UPLOAD_BULK_CANDIDATE_DATA,
        payload: {
          data: Document,
          courseid: courseid,
          getDataInterval: getDataInterval,
          setIntervalId: setIntervalId,
          setStatusModalOpen: setStatusModalOpen,
        },
      });
      // let response = await axios.post(`${API_URL}/backoffice/bulkuploadcandidate`, formData)
    } else {
      setDocumentError("please select a Document");
    }
  };
  const onChangeCourse = async (e) => {
    setCourseId(e.target.value);
  };
  const handleDownloadTemplate = async()=>{
   try{
    // const fileUrl = ''; 

    // const res = await fetch(fileUrl);
    // const response = res.clone();
    // const blob = await response.blob();
      
    //   // Create a blob URL
    //   const blobUrl = window.URL.createObjectURL(  new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    // if (!response.ok) {
    //   throw new Error('File not found. Please make sure the file exists in the assets folder.');
    // }
    const link = document.createElement('a');
    link.href = Template;
    
    link.setAttribute('download', 'bulk_upload_template.xlsx');
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
   }catch(err){
   }
  }
  return (
    <>
      <Box
        sx={{
          padding: "20px 25px 0px 25px",
          minHeight: "60vh",
          backgroundColor: "#fff",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2}>
        <Grid item md={12}>
        <GreenButton
                handleSubmit={handleDownloadTemplate}
                title="Download Template"
              />
        </Grid>
          <Grid item md={12}>
          <InputLabel style={{ fontWeight: "bold" }}>
              Select Course
              <span className="error" style={{ color: "#666666" }}>
                *
              </span>
            </InputLabel>
            <Box>
              <Select
                size="small"
                onChange={onChangeCourse}
                value={courseid ?? ""}
                defaultValue={0}
                sx={{ width: "auto", minWidth: "200px" }}
              >
                <MenuItem value={0} selected>
                  Courses
                </MenuItem>
                {courseList?.all?.map((course, i) => (
                  <MenuItem key={i} value={course.courseid}>
                    {course.coursename}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item md={12}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Upload Document
              <span className="error" style={{ color: "#666666" }}>
                *
              </span>
            </InputLabel>
            {!Document && (
              <Box
                style={{
                  border: "1px dashed gray",
                  maxWidth: "330px",
                  minHeight: "32px",
                  display: "flex",
                  alignItems: "center",
                  marginTop: 2,
                }}
                onDrop={handleDocumentDrop}
                onDragOver={handleDragOver}
              >
                <input
                  type="file"
                  name="documentfilename"
                  id="documentfilename"
                  accept=".xlsx"
                  style={{
                    width: "0.1px",
                    height: "0.1px",
                    opacity: 0,
                    overflow: "hidden",
                    position: "absolute",
                    zIndex: -1,
                  }}
                  onChange={handleDocumentUpload}
                />
                <label
                  htmlFor="documentfilename"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  &nbsp; <IoCloudUploadOutline size={22} /> &nbsp; Drag or drop
                  your Document, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </label>
              </Box>
            )}
            {Document && (
              <Box
                style={{
                  width: "17.6em",
                  height: "45px",
                  border: "1px solid #D5D5D5",
                  display: "flex",
                  alignItems: "center",
                  gap: "1%",
                  marginTop: "1rem",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  margin: "6px 0px 0px 8px",
                }}
              >
                <img
                  src={xlsx}
                  style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                  alt="xlsx"
                />
                <span
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {Document?.name}
                </span>
                <PiX
                  style={{ margin: 0, padding: 0, cursor: "pointer" }}
                  onClick={handleCloseDocument}
                />
              </Box>
            )}
            {documentError && documentError !== "" && (
              <Box sx={{ marginTop: 2 }}>
                <Typography
                  variant="caption"
                  sx={{ textAlign: "center", color: "red" }}
                >
                  {documentError}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid item md={12}>
            <Box sx={{ marginTop: 2 }}>
              <BluePrimaryButton
                title={"Submit"}
                handleSubmit={() => handleSubmit(Document, courseid)}
                disabled={!courseid || !Document}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box my={2}>
          { statusModalopen?.isloader == true &&  <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />}
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
    </>
  );
};

export default Index;
